import {
  Button,
  Column,
  Container,
  Img,
  Link,
  Row,
  Section
} from '@react-email/components'
import { truncate } from 'lodash'

import { getMapThumbnailLink } from 'utils'

import {
  Footer,
  Mapstack,
  SplitContent,
  Text,
  WhatIsMapstack
} from 'ms-email/components'
import { Email } from 'ms-email/emails/components/Email'
import { borderRadius } from 'ms-email/themes/border-radius'
import { button } from 'ms-email/themes/button'
import { typography } from 'ms-email/themes/typography'
import { getFullname } from 'ms-email/utils/get-fullname'

export function MapGuestInvitation(props) {
  const { map, user, inviteUrl } = props

  const fullname = getFullname(user)
  const thumbnail = getMapThumbnailLink({
    id: map.id,
    updatedAt: map.updatedAt
  })

  return (
    <Email
      title={`Action required: ${fullname} invited you to view their map on Mapstack`}
      preview={'Map guest invitation'}
    >
      <Container style={{ paddingBlock: 64 }}>
        <Mapstack />
        <InvitationHeader
          fullname={fullname}
          mapName={map.name}
        />
        <SplitContent
          first={
            <MapDetails
              mapName={map.name}
              avatar={user.avatar}
              inviteUrl={inviteUrl}
            />
          }
          second={
            <MapThumbnail
              mapName={map.name}
              thumbnail={thumbnail}
              inviteUrl={inviteUrl}
            />
          }
        />
        <WhatIsMapstack />
        <Footer />
      </Container>
    </Email>
  )
}

function InvitationHeader(props) {
  const { fullname, mapName } = props
  return (
    <Section>
      <Text
        style={{
          marginTop: 32,
          ...typography.h5
        }}
      >
        Access this map on Mapstack
      </Text>

      <Text
        style={{
          marginTop: 32,
          ...typography.body1
        }}
      >
        <b>{fullname}</b> has invited you to access their map called&nbsp;
        <b>{mapName}</b>.
      </Text>
    </Section>
  )
}

function MapDetails(props) {
  const { mapName, avatar, inviteUrl } = props
  return (
    <Section style={{ padding: 24 }}>
      <Row>
        <Column align='center'>
          <Img
            src={avatar}
            alt='Owner Avatar'
            width={75}
            height={75}
            style={{ borderRadius: borderRadius.rounded }}
          />
        </Column>
      </Row>
      <Row>
        <Column
          align='center'
          style={{ paddingTop: 16 }}
        >
          <Text
            style={{
              ...typography.body1,
              fontWeight: 700
            }}
          >
            {mapName}
          </Text>
        </Column>
      </Row>
      <Row>
        <Column
          align='center'
          style={{ paddingTop: 16 }}
        >
          <Link href={inviteUrl}>
            {truncate(inviteUrl, {
              length: 45,
              omission: '...'
            })}
          </Link>
        </Column>
      </Row>
      <Row>
        <Column
          align='center'
          style={{ paddingTop: 16 }}
        >
          <Button
            href={inviteUrl}
            style={button.primary('medium')}
          >
            View the map
          </Button>
        </Column>
      </Row>
    </Section>
  )
}

function MapThumbnail(props) {
  const { mapName, inviteUrl, thumbnail } = props
  return (
    <Section style={{ padding: 24 }}>
      <Row>
        <Column align='center'>
          <Text
            style={{
              ...typography.body1,
              marginBlock: 0,
              fontWeight: 600
            }}
          >
            {mapName}
          </Text>
        </Column>
      </Row>
      <Row style={{ paddingTop: 16 }}>
        <Column align='center'>
          <Link href={inviteUrl}>
            <Img
              src={thumbnail}
              alt='Map Thumbnail'
              width={75}
              height={75}
              style={{
                marginBottom: 0,
                borderRadius: borderRadius.rounded
              }}
            />
          </Link>
        </Column>
      </Row>
    </Section>
  )
}
